import { observable, computed } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import LeftOpenBoxStore from './components/left-open-box/store';
import RightOpenBoxStore from './components/right-open-box/store';
import StorageBoxStore from './components/storage-box/store';
import ChronicleModalStore from '@src/business-components/chronicle-modal/store';
import ChronicleModal from '@src/business-components/chronicle-modal';
import PersonalCenterModalStore from '@src/business-components/personalCenter-modal/store';
import PersonalCenterModal from '@src/business-components/personalCenter-modal';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import useModal from '@src/utils/hooks/use-modal';
import { useEffect } from 'react';
import axios from 'axios';
import NaviBarStore from '@src/business-components/navibar/store';

const API = 'https://omni-api.seasungames.com/api/omni/v1/openapi';

const POSITION = 'channel_cat_332174d2'; // 分发位置标识
const DATASOURCE_ID = 'ds_cat_2174d20f'; // 数据源标识 - 旧世简时
const DATASOURCE_ID2 = 'ds_cat_7269ee99'; // 数据源标识 - 复兴纪元

// const query_API = 'https://omni-api.seasungames.com/api/omni/v1/openapi/search/index';
// const SEARCH_ID = 'channel_index_2aa600e4'; // 搜索池的id
// const OMNI_DS = 'index_ds_0e4a1363'; // 搜索数据源的id

// 搜索接口替换列表接口 channel_cat_332174d2 ds_cat_e1ecaaa9
const LIST_ID = 'channel_cat_332174d2'; // 列表池的id
const DS_ID = 'ds_cat_e1ecaaa9'; // 列表数据源的id

class CatalogueStore extends BaseStore {
  //  true 左侧打开-右侧关闭 世界简史   false 左侧关闭-右侧打开 复兴纪元
  @observable isLeftTitleOpen = true;
  naviBarStore = new NaviBarStore();
  // 旧世简史-左侧展开卡片点击事件
  leftOpenBoxStore = new LeftOpenBoxStore({
    listClickCallback: (item, index) => {
      // this.getDetail(item);
      this.getDetailedOpenModal(item, index);
    },
    // 分页
    scrollToBottomCallback: () => {
      if (this.jsjsLoading || !this.jsjsHasMore) return;
      this.jsjsLoading = true;
      const nextPage = this.jsjsCurrentPage + 1; // 关键：页码+1
      this.getWorldHistory(nextPage, this.jsjsPerPage).finally(() => {
        this.jsjsLoading = false;
      });
    }
  });
  // 复兴纪元-右侧展开卡片
  rightOpenBoxStore = new RightOpenBoxStore({
    listClickCallback: (item, index) => {
      // this.getDetail(item);
      this.getDetailedOpenModal(item, index);
    },
    scrollToBottomCallback: () => {
      if (this.fxjyLoading || !this.fxjyHasMore) return;
      this.fxjyLoading = true;
      const nextPage = this.fxjyCurrentPage + 1; // 关键：页码+1
      this.getWorldRevival(nextPage, this.fxjyPerPage).finally(() => {
        this.fxjyLoading = false;
      });
    }
  });
  // 收纳盒
  storageBoxStore = new StorageBoxStore({
    click_fn: id => {
      this.isLeftTitleOpen = !this.isLeftTitleOpen;
      if (id.includes('fxjy')) {
        this.rightOpenBoxStore.maodianid = id;
      } else if (id.includes('jsjs')) {
        this.leftOpenBoxStore.maodianid = id;
      }
    },
    scrollToBottomCallback: () => {
      // 收纳盒要做取反请求
      if (this.isLeftTitleOpen) {
        //复兴纪元
        if (this.fxjyLoading || !this.fxjyHasMore) return;
        this.fxjyLoading = true;
        const nextPage = this.fxjyCurrentPage + 1; // 关键：页码+1
        this.getWorldRevival(nextPage, this.fxjyPerPage).finally(() => {
          this.fxjyLoading = false;
        });
      } else {
        //旧世简史
        if (this.jsjsLoading || !this.jsjsHasMore) return;
        this.jsjsLoading = true;
        const nextPage = this.jsjsCurrentPage + 1; // 关键：页码+1
        this.getWorldHistory(nextPage, this.jsjsPerPage).finally(() => {
          this.jsjsLoading = false;
        });
      }
    }
  });
  // 编年史弹窗
  chronicleModalStore = new ChronicleModalStore({
    // 根据index去拿列表的数据，然后请求详情+搜索人物+搜索势力 在弹窗更新数据
    switchCallback: type => {
      if (type === 'prev') {
        const prevIndex = this.activeIndex - 1;
        if (this.isLeftTitleOpen) {
          this.getDetailedOpenModal(this.jsjsData[prevIndex], prevIndex);
        } else {
          this.getDetailedOpenModal(this.fxjyData[prevIndex], prevIndex);
        }
      } else if (type === 'next') {
        const nextIndex = this.activeIndex + 1;
        if (this.isLeftTitleOpen) {
          this.getDetailedOpenModal(this.jsjsData[nextIndex], nextIndex);
        } else {
          this.getDetailedOpenModal(this.fxjyData[nextIndex], nextIndex);
        }
      }
    }
  });
  // 个人中心弹窗
  personalCenterModalStore = new PersonalCenterModalStore();

  @observable activeIndex = null;

  // 旧世简史
  @observable jsjsData = null;
  // 旧世简史-总数
  @observable jsjsTotal = 0;
  // 旧世简史-页码
  @observable jsjsCurrentPage = 1;
  // 旧世简史-每页数量
  jsjsPerPage = 90;
  // 旧世简史-总页数
  @computed
  get jsjsTotalPage() {
    return Math.ceil(this.jsjsTotal / this.jsjsPerPage);
  }
  // 旧世简史是否加载完毕（无更多数据）
  @observable jsjsHasMore = true;
  // 旧世简史-是否加载中
  @observable jsjsLoading = false;

  // 复兴纪元
  @observable fxjyData = null;
  // 复兴纪元-总数
  @observable fxjyTotal = 0;
  //  复兴纪元-页码
  @observable fxjyCurrentPage = 1;
  // 复兴纪元-每页数量
  fxjyPerPage = 50;
  // 复兴纪元-总页数
  @computed
  get fxjyTotalPage() {
    return Math.ceil(this.fxjyTotal / this.fxjyPerPage);
  }
  // 复兴纪元是否加载完毕（无更多数据）
  @observable fxjyHasMore = true;
  // 复兴纪元-是否加载中
  @observable fxjyLoading = false;

  // 获取编年史列表
  getList(dataSourceId, page, perPage) {
    return axios
      .get(`${API}/get_position_data`, {
        params: {
          param: JSON.stringify({
            lang: getLanguageByPath(),
            positions: [
              {
                position: POSITION,
                dataSources: [
                  {
                    dataSourceId: dataSourceId,
                    page: page,
                    perPage: perPage,
                    withMeta: true
                  }
                ]
              }
            ]
          }),
          format: ''
        }
      })
      .then(res => {
        const newData = res?.data?.data?.[POSITION]?.[dataSourceId]?.result?.items || []; // 兜底空数组
        const total = res?.data?.data?.[POSITION]?.[dataSourceId]?.result?.total || 0;
        if (dataSourceId === DATASOURCE_ID) {
          // 分页追加数据
          if (page === 1) {
            // 第一页：重置数据（初始化/刷新）
            this.jsjsData = newData;
          } else {
            // 非第一页：追加数据到原有数组后
            this.jsjsData = [...(this.jsjsData || []), ...newData];
          }
          // 同步更新左侧组件的数据源（也要追加，否则组件只显示最后一页）
          this.leftOpenBoxStore.data = this.jsjsData;
          this.jsjsTotal = total;
        } else if (dataSourceId === DATASOURCE_ID2) {
          if (page === 1) {
            this.fxjyData = newData;
          } else {
            this.fxjyData = [...(this.fxjyData || []), ...newData];
          }
          this.rightOpenBoxStore.data = this.fxjyData;
          this.fxjyTotal = total;
        }

        // 关键：返回当前页的新数据，供分页方法判断
        return newData;
      })
      .catch(err => {
        console.log('获取活动列表失败', err);
        throw err; // 抛出错误，让外层async/await能捕获
      });
  }
  // 获取编年史详情
  getDetail = async item => {
    try {
      // 1. 等待详情接口请求完成（替换原来的then链式调用）
      const res = await axios.get(`${API}/get_detail`, {
        params: {
          format: 'ds',
          param: JSON.stringify({
            lang: getLanguageByPath(),
            contentId: item?.contentId
          }),
          withEntry: true
        }
      });
      // 2. 处理详情数据
      const data = res?.data?.data?.[item?.contentId];
      const dictData = res?.data?.data?.['_omni_dict'];
      this.chronicleModalStore.data = data;
      this.chronicleModalStore.dictData = dictData;
      // 3. 收集需要执行的异步任务（避免无意义的请求）
      const asyncTasks = [];
      if (item?.characters !== '' && item?.characters) {
        // 增加非空判断，更严谨
        asyncTasks.push(this.getSearchCharacter(item?.characters));
      } else {
        this.chronicleModalStore.characterDataMap = null;
      }

      if (item?.factions !== '' && item?.factions) {
        // 增加非空判断，更严谨
        asyncTasks.push(this.getSearchInFactions(item?.factions));
      } else {
        this.chronicleModalStore.factionDataMap = null;
      }
      // 4. 等待所有异步任务执行完成（并行执行，效率更高）
      await Promise.all(asyncTasks);
      // 5. 所有任务完成后，再打开弹窗（核心需求）
      // this.chronicleModalStore.isOpen = true;
      // this.chronicleModal.open();
    } catch (err) {
      console.log('获取活动详情失败', err);
    }
  };
  // 关联人物
  async getSearchCharacter(omni_text) {
    this.chronicleModalStore.characterDataMap = await this.getSearch(omni_text);
  }
  // 关联势力
  async getSearchInFactions(omni_text) {
    this.chronicleModalStore.factionDataMap = await this.getSearch(omni_text);
  }

  // 获取详情数据弹出弹窗
  getDetailedOpenModal = async (item, index) => {
    if (!item) return;
    this.activeIndex = index;
    await this.getDetail(item);
    // 列表长度
    if (this.isLeftTitleOpen) {
      this.chronicleModalStore.listLength = this.jsjsTotal;
    } else {
      this.chronicleModalStore.listLength = this.fxjyTotal;
    }
    this.chronicleModalStore.activeIndex = index;
    if (!this.chronicleModalStore.isOpen) {
      this.chronicleModalStore.isOpen = true;
      this.chronicleModal.open();
    }
  };

  // // 通过查询条件获取 关联人物和关联势力
  // getSearch(omni_text) {
  //   return axios
  //     .get(`${query_API}/${SEARCH_ID}`, {
  //       params: {
  //         _omni_ds: OMNI_DS,
  //         _omni_text: omni_text,
  //         lang: getLanguageByPath(),
  //         page: 1,
  //         perPage: 99
  //       }
  //     })
  //     .then(res => {
  //       const data = res?.data?.data?.items;
  //       return data;
  //     })
  //     .catch(err => {
  //       console.log('获取查询详情失败', err);
  //     });
  // }

  // 通过查询条件获取 关联人物和关联势力
  getSearch(omni_text) {
    const value = omni_text
      .split(',')
      .map(item => item.trim())
      .filter(item => item); // 过滤空字符串
    return axios
      .get(`${API}/get_position_data`, {
        params: {
          param: JSON.stringify({
            lang: getLanguageByPath(),
            positions: [
              {
                position: LIST_ID,
                dataSources: [
                  {
                    dataSourceId: DS_ID,
                    page: 1,
                    perPage: 99,
                    // withMeta: true
                    contentFilter: {
                      items: [
                        // 过滤规则列表
                        {
                          field: 'entry_id', // 过滤字段：条目ID
                          operator: 'in', // 字符串包含（in表示value数组中的任意一个）
                          value: value // 过滤值列表
                        }
                      ]
                    }
                  }
                ]
              }
            ]
          }),
          format: ''
        }
      })
      .then(res => {
        const data = res?.data?.data?.[LIST_ID]?.[DS_ID]?.result?.items || []; // 兜底空数组
        return data;
      })
      .catch(err => {
        console.log('查询失败', err);
        throw err;
      });
  }

  // 旧世简史-分页请求
  getWorldHistory = async (page, perPage) => {
    // 核心拦截：1.无更多数据 2.页码非法 3.重复请求
    if (!this.jsjsHasMore || page < 1 || page === this.jsjsCurrentPage) {
      console.log('旧世简史无需请求：', !this.jsjsHasMore ? '无更多数据' : page < 1 ? '页码非法' : '重复请求');
      return;
    }
    // 更新当前页码
    this.jsjsCurrentPage = page;
    try {
      const newData = await this.getList(DATASOURCE_ID, page, perPage);
      // 核心判断：返回数据长度 < 每页数量 → 无更多数据
      this.jsjsHasMore = newData?.length === perPage;
    } catch (err) {
      console.log('旧世简史分页请求失败：', err);
      // 请求失败：回滚页码（避免页码错乱）
      this.jsjsCurrentPage = page - 1;
    }
  };
  // 复兴纪元-分页请求
  getWorldRevival = async (page, perPage) => {
    // 核心拦截：1.无更多数据 2.页码非法 3.重复请求
    if (!this.fxjyHasMore || page < 1 || page === this.fxjyCurrentPage) {
      console.log('复兴纪元无需请求：', !this.fxjyHasMore ? '无更多数据' : page < 1 ? '页码非法' : '重复请求');
      return;
    }

    // 更新当前页码
    this.fxjyCurrentPage = page;

    try {
      const newData = await this.getList(DATASOURCE_ID2, page, perPage);
      // 核心判断：返回数据长度 < 每页数量 → 无更多数据
      this.fxjyHasMore = newData?.length === perPage;
    } catch (err) {
      console.log('复兴纪元分页请求失败：', err);
      // 请求失败：回滚页码
      this.fxjyCurrentPage = page - 1;
    }
  };
  use() {
    super.use();
    // 编年史弹窗
    this.chronicleModal = useModal(ChronicleModal, { store: this.chronicleModalStore });
    // 个人中心弹窗
    this.personalCenterModal = useModal(PersonalCenterModal, { store: this.personalCenterModalStore });
    // 组件挂载时获取活动列表
    useMount(async () => {
      // 组件挂载时重置标记
      this.jsjsHasMore = true;
      this.fxjyHasMore = true;
      // 组件挂载时获取活动列表
      this.getList(DATASOURCE_ID, 1, this.jsjsPerPage);
      this.getList(DATASOURCE_ID2, 1, this.fxjyPerPage);
      this.naviBarStore.currentIndex = 2;
    });

    useEffect(
      () => {
        // 初始化时根据isLeftTitleOpen状态设置收纳盒数据
        if (this.isLeftTitleOpen) {
          this.storageBoxStore.data = this.fxjyData;
        } else {
          this.storageBoxStore.data = this.jsjsData;
        }
      },
      [this.isLeftTitleOpen, this.fxjyData, this.jsjsData]
    );
    // 切换状态通知组件
    useEffect(
      () => {
        this.leftOpenBoxStore.isLeftTitleOpen = this.isLeftTitleOpen;
        this.storageBoxStore.isLeftTitleOpen = this.isLeftTitleOpen;
        this.rightOpenBoxStore.isRightTitleOpen = !this.isLeftTitleOpen;
      },
      [this.isLeftTitleOpen]
    );
  }
}

export default CatalogueStore;
